
const getAuthenticationMethods = t => [
  {
    id: 1,
    method: 'mobiilivarmenne-ftn',
    name: t('common:authenticationMethods.mobileCertificate'),
    logo: 'mobiilivarmenne'
  },
  {
    id: 2,
    method: 'ftn-nordea-auth',
    name: 'Nordea',
    logo: 'nordea'
  },
  {
    id: 3,
    method: 'ftn-danskebank-auth',
    name: 'Danske Bank',
    logo: 'danskebank'
  },
  {
    id: 4,
    method: 'ftn-op-auth',
    name: t('common:authenticationMethods.osuuspankki'),
    logo: 'osuuspankki'
  },
  {
    id: 5,
    method: 'ftn-spankki-auth',
    name: t('common:authenticationMethods.sBank'),
    logo: 'spankki'
  },
  {
    id: 6,
    method: 'ftn-aktia-auth',
    name: 'Aktia',
    logo: 'aktia'
  },
  {
    id: 7,
    method: 'ftn-alandsbanken-auth',
    name: 'Ålandsbanken',
    logo: 'alandsbanken'
  },
  {
    id: 8,
    method: 'ftn-omasp-auth',
    name: t('common:authenticationMethods.omaSavingsBank'),
    logo: 'omasaastopankki'
  },
  {
    id: 9,
    method: 'ftn-sp-auth',
    name: t('common:authenticationMethods.savingsBank'),
    logo: 'saastopankki'
  },
  {
    id: 10,
    method: 'ftn-pop-auth',
    name: t('common:authenticationMethods.popBank'),
    logo: 'poppankki'
  }
];

export default getAuthenticationMethods;



// WEBPACK FOOTER //
// ./src/components/BankSelection/methods.js